export default "__VITE_ASSET__RAz2cBHm__"